import { Controller } from "web-ui/controller"

export default class extends Controller {
  // The exit is two phases, each begun by the parent. `exit` plays the
  // `notice-exit` keyframe at full height and dispatches `notice:exited` when
  // it ends. `collapse` then transitions to reduce the height of the notice to
  // 0; when that ends the notice removes itself and dispatches
  // `notice:collapsed`. Splitting the phases lets the parent hold all
  // slide-outs at frozen height and then collapse the rows in lockstep with the
  // container shrinking.
  // - Aaron, Thu Jun 4 2026
  exit() {
    // Remove the id before exiting so an immediate subsequent re-add of the
    // same content is a fresh element rather than matched to this one on its
    // way out. - Aaron, Thu Jun 4 2026
    this.element.removeAttribute("id")

    this.onAnimationEnd(() => {
      this.dispatch("exited", { bubbles: true })
    })

    this.element.classList.add("exiting")
  }

  collapse() {
    this.onTransitionEnd("grid-template-rows", () => {
      this.dispatch("collapsed", { bubbles: true })
      this.element.remove()
    })

    this.element.classList.add("collapsing")
  }

  get message() {
    return this.element.querySelector(":scope > .message")
  }

  update(source) {
    const message = this.message
    const incoming = source.querySelector(":scope > .message")

    // Only update if there are changes in order to avoid unnecessarily
    // recreating DOM elements - Aaron, Thu Jun 4 2026
    if (message.className !== incoming.className || message.innerHTML !== incoming.innerHTML) {
      message.className = incoming.className
      message.innerHTML = incoming.innerHTML
    }

    const emphasized = source.classList.contains("emphasized")
    this.element.classList.toggle("emphasized", emphasized)

    if (emphasized) {
      this.pulse()
    }
  }

  pulse() {
    const message = this.message

    message.classList.remove("pulse")

    // Force reflow so adding the pulse class back will trigger an animation
    // - Aaron, Thu Jun 4 2026
    void message.offsetWidth

    message.classList.add("pulse")
  }

  onAnimationEnd(callback) {
    const handler = (event) => {
      if (event.target !== this.element) {
        return
      }

      this.element.removeEventListener("animationend", handler)
      callback()
    }

    this.element.addEventListener("animationend", handler)
  }

  onTransitionEnd(property, callback) {
    const handler = (event) => {
      if (event.target !== this.element || event.propertyName !== property) {
        return
      }

      this.element.removeEventListener("transitionend", handler)
      callback()
    }

    this.element.addEventListener("transitionend", handler)
  }
}
